/**
 * Created by kostas.manionis on 7/20/15.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var FullscreenView = require('./views/FullscreenView');
var mobileAdsHelpers = require('./helpers/mobileAdsHelpers');
var constants = require('./mobileAdsConstants');

module.exports = {
    showAd: function () {
        var ad = new FullscreenView({
            'adName': constants.FULLSCREEN_NAME
        });

        ad.render();
        $('body').append(ad.$el);
        mobileAdsHelpers.setCookie();
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/mobileAds/mobileAdsBase.js
// module id = 2573
// module chunks = 64